import { Grid, GridColumn, GridRowClickEvent, GridToolbar } from '@progress/kendo-react-grid';
import React from 'react';
import { connect } from 'react-redux'
import { Button, Label } from 'reactstrap'
import Redux from 'redux'
import * as Form from '../../../components/form'
import * as Attributes from '../attributes'
import * as Actions from './actions'

interface State {
  attributes: Attributes.Attribute[],
  dispatch: Redux.Dispatch<Redux.Action>,
  onAdd: Actions.AddAttributeFn,
  onChange: Actions.UpdateAttributeFn,
  onClick: Actions.EditAttributeFn,
}

interface ChangeEvent {
  dataItem: Attributes.Attribute,
  field?: string,
  value: string,
}

const asFormField = (e: ChangeEvent): Form.Field<string> => e.field === 'name' ?
    {
      name: e.value,
      value: e.dataItem.value,
    }
  : {
      name: e.dataItem.name,
      value: e.value,
    }

const AttributeGridComponent = ({attributes, dispatch, onAdd, onClick, onChange}: State) =>
  <div>
    <Label className={'field-label'}>
      <span>Attributes</span>
    </Label>
    <Grid
        data={attributes}
        editField="is_editing"
        onRowClick={(e: GridRowClickEvent) => dispatch(onClick(e.dataItem.index))}
        onItemChange={(e: ChangeEvent) => dispatch(onChange(e.dataItem.index, asFormField(e)))}
    >
      <GridToolbar>
        <Button title="Add new" className="k-button k-primary"
                onClick={(e: any) => dispatch(onAdd())}>Add Attribute</Button>
      </GridToolbar >
      <GridColumn field="name" title="Name" editable={true}/>
      <GridColumn field="value" title="Value" editable={true}/>
    </Grid >
  </div>

export const AttributeGrid = connect(
  null,
  (dispatch: Redux.Dispatch<Redux.Action>) => ({
    dispatch,
    onAdd: Actions.addAttribute,
    onChange: Actions.updateAttribute,
    onClick: Actions.editAttribute,
  }),
)(AttributeGridComponent)



// WEBPACK FOOTER //
// ./src/pages/members/add-modal/attribute-grid.tsx